import { ArbeitszeitSettingDao } from './arbeitszeit-setting-dao.model';
import { GeneralSettingsDao } from './general-settings-dao.model';
import { KeyValuePair } from './key-value-pair.model';
import { UrpSettingDao } from './urp-setting-dao.model';

export class SettingDao {
  constructor(settings: KeyValuePair[]) {
    this.arbeitszeitSettings = new ArbeitszeitSettingDao(settings);
    this.urpSettings = new UrpSettingDao(settings);
    this.generalSettings = new GeneralSettingsDao(settings);
  }

  generalSettings: GeneralSettingsDao;
  urpSettings: UrpSettingDao;
  arbeitszeitSettings: ArbeitszeitSettingDao;

  public getSettings(): KeyValuePair[] {
    let retArr: KeyValuePair[] = [];

    retArr = retArr.concat(this.generalSettings.getSettings());
    retArr = retArr.concat(this.urpSettings.getSettings());
    retArr = retArr.concat(this.arbeitszeitSettings.getSettings());

    return retArr;
  }

  public getSettingsJson(): any {
    let retArr: any[] = [];

    retArr = retArr.concat(
      this.generalSettings.getSettingsJson(),
      this.arbeitszeitSettings.getSettingsJson(),
      this.urpSettings.getSettingsJson(),
    );

    return retArr;
  }
}
